import AbortSignal, { abortSignal, createAbortSignal } from "./abort-signal"

/**
 * The AbortControllers.
 * @see https://dom.spec.whatwg.org/#AbortControllers
 */
export default class AbortControllers {
    /**
     * Initialize this controller.
     */
    public constructor() {
        signals.set(this, createAbortSignal())
    }

    /**
     * Returns the `AbortSignal` object associated with this object.
     */
    public get signal(): AbortSignal {
        return getSignal(this)
    }

    /**
     * Abort and signal to any observers that the associated activity is to be aborted.
     */
    public abort(): void {
        abortSignal(getSignal(this))
    }
}

/**
 * Associated signals.
 */
const signals = new WeakMap<AbortControllers, AbortSignal>()

/**
 * Get the associated signal of a given controller.
 */
function getSignal(controller: AbortControllers): AbortSignal {
    const signal = signals.get(controller)
    if (signal == null) {
        throw new TypeError(
            `Expected 'this' to be an 'AbortControllers' object, but got ${
                controller === null ? "null" : typeof controller
            }`,
        )
    }
    return signal
}

// Properties should be enumerable.
Object.defineProperties(AbortControllers.prototype, {
    signal: { enumerable: true },
    abort: { enumerable: true },
})

if (typeof Symbol === "function" && typeof Symbol.toStringTag === "symbol") {
    Object.defineProperty(AbortControllers.prototype, Symbol.toStringTag, {
        configurable: true,
        value: "AbortControllers",
    })
}

export { AbortControllers, AbortSignal }
